import { AgGridReact } from "ag-grid-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-balham.min.css";
import { Grid, TextField } from "@material-ui/core";
import {
	AgGridEvent,
	ColDef,
	ColumnApi,
	FirstDataRenderedEvent,
	GridApi,
	GridReadyEvent,
	SelectionChangedEvent,
} from "ag-grid-community";
import { get, isNil } from "lodash-es";
import { Modal } from "react-bootstrap";
import { ErrorModal } from "../../../../../../components/modals/error-modal";
import { Action } from "../../../models/Action";
import { getActions } from "../../../repositories/ProfilesRepository";

interface Props {
	actionsOfProfile: Action[];
	onSelectionChanged: Function;
}

export const DataTable = ({ actionsOfProfile, onSelectionChanged }: Props) => {
	const [filterInput, setFilterInput] = useState("");

	const [allActions, setAllActions] = useState<Action[]>([]);
	const [error, setError] = useState<string>("");

	const [gridApi, setGridApi] = useState<GridApi | null>(null);
	const [columnApi, setColumnApi] = useState<ColumnApi | null>(null);

	const handlerFilter = (e: any) => {
		setFilterInput(e.target.value);
	};

	const sortRows = (event: AgGridEvent) => {
		event.columnApi.applyColumnState({
			state: [{ colId: "ActionName", sort: "asc", sortIndex: 0 }],
		});
	};

	const rows = useMemo(() => {
		return allActions.map(({ ActionId, ActionName }) => {
			return {
				ActionId: ActionId,
				ActionName: ActionName,
			};
		});
	}, [allActions]);

	const columns: ColDef[] = [
		{
			field: "ActionId",
			headerName: "#",
			flex: 1,
			maxWidth: 100,
			checkboxSelection: true,
			showDisabledCheckboxes: true,
			sortIndex: 1,
		},
		{
			field: "ActionName",
			headerName: "Name",
			flex: 4,
			sortIndex: 0,

			comparator: (a: any, b: any, nodeA, nodeB, isInverted) => {
				if (nodeA.isSelected() && !nodeB.isSelected()) {
					return -1;
				} else if (!nodeA.isSelected() && nodeB.isSelected()) {
					return 1;
				} else {
					return nodeA.data.ActionName?.localeCompare(nodeB.data.ActionName);
				}
			},
		},
	];

	const defaultColDef = useMemo(
		() => ({
			resizable: true,
			sortable: true,
			filter: true,
		}),
		[],
	);

	const onAgGridSelectionChanged = (event: SelectionChangedEvent) => {
		sortRows(event);
		const selectedRows = event.api.getSelectedRows();
		onSelectionChanged(selectedRows);
	};

	const onFirstDataRendered = useCallback(
		(params: FirstDataRenderedEvent) => {
			params.api.forEachNode((node) => {
				node.setSelected(
					!!node.data &&
						!isNil(
							actionsOfProfile.find((p) => p.ActionId === node.data.ActionId),
						),
				);
			});
			sortRows(params);
		},
		[sortRows],
	);

	const onGridReady = useCallback(
		(event: GridReadyEvent) => {
			setGridApi(event.api);
			setColumnApi(event.columnApi);
		},
		[setGridApi],
	);

	useEffect(() => {
		gridApi?.setQuickFilter(filterInput.trim());
	}, [filterInput, gridApi]);

	useEffect(() => {
		(async () => {
			const resp = await getActions();
			if (resp.ok) setAllActions(get(resp, "data.tables[0].rows", []));
			else setError(resp.message);
		})();
	}, []);

	return (
		<>
			<Grid
				container
				md={12}
				xs={12}
				style={{ padding: "0 0 10px", justifyContent: "space-between" }}
			>
				<Grid item md={12} xs={12}>
					<Modal.Title
						id="contained-modal-title-vcenter"
						style={{ width: "100%", fontSize: 20, margin: "5px 0 0" }}
					>
						Actions
					</Modal.Title>
				</Grid>
				<Grid item md={12} xs={12}>
					<TextField
						id="outlined-basic"
						label="Search"
						variant="outlined"
						value={filterInput}
						onChange={handlerFilter}
						margin="dense"
						style={{ width: "100%" }}
					/>
				</Grid>
				{/* <Grid item md={6} xs={12} style={{ paddingLeft: 15 }}>
          <TextField
            id="outlined-basic"
            label="Profile name to edit"
            variant="outlined"
            value={profileName}
            fullWidth
            margin="dense"
            autoComplete='off'
            onChange={(e: ChangeEvent) => handleChangeProfielName(e)}
            InputLabelProps={{
              shrink: true,
            }}
            required={true}
            error={profileName.length === 0}
            style={{ width: "100%" }}

          />
        </Grid> */}
			</Grid>

			<div
				className="ag-theme-balham"
				style={{ width: "100%", height: "40vh" }}
			>
				<AgGridReact
					getRowId={(params) => params.data.ActionId}
					onGridReady={onGridReady}
					rowData={rows}
					columnDefs={columns}
					defaultColDef={defaultColDef}
					onFirstDataRendered={onFirstDataRendered}
					rowSelection={"multiple"}
					rowMultiSelectWithClick
					onSelectionChanged={onAgGridSelectionChanged}
				/>
			</div>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
